import { useEffect, useState } from "react";

/**
 * Returns a value that updates only after `delayMs` of no changes.
 * Keeps the input responsive while avoiding a request on every keystroke.
 */
export default function useDebouncedValue(value, delayMs = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debouncedValue;
}
